/* Duskhaven product cards: hover scrub (2026-10-21 sample, draft 5.8; v2 same day; v3 2026-10-28: 5 photos).
 * With a mouse, moving across the card photo steps through its first 5 photos (left edge = photo 1, right edge = photo 5).
 * dh-card-gallery.js still owns hydrating the extra photos, the arrows, swipe and quick view; this file only picks the visible
 * slide from the pointer position. Delegated, so search-panel cards work too. Needs 3+ photos; otherwise the plain image-2 hover stays.
 * v2: (1) a card only starts scrubbing after the pointer has been over it for HOLD ms, so sweeping the cursor across a grid
 * does not flicker every card; until then the card stays on photo 1 (is-nav switches off the plain image-2 hover).
 * (2) the visible photo only changes once the next one has loaded, so a slow connection never shows an empty frame;
 * all 5 photos start loading on the first move over the card.
 * v3 (Todd, 2026-10-28): 5 photos and 5 dots instead of 4 (MAX below). Cards with fewer photos scrub across what they have. */
(function () {
  if (window.__dhCardScrub) return;
  window.__dhCardScrub = true;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var MAX = 5;
  var HOLD = 80;
  var SEL = '.dh-card--gallery [data-dh-card-media]';

  function ensureDots(media, n) {
    var dots = media.querySelector('.dh-card-scrub');
    if (dots && dots.children.length === n) return dots;
    if (dots) dots.remove();
    dots = document.createElement('div');
    dots.className = 'dh-card-scrub';
    dots.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
    media.appendChild(dots);
    return dots;
  }

  function loaded(img) { return img.complete && img.naturalWidth > 0; }

  // Swap the visible photo; waits for the photo to arrive so the frame is never empty.
  function apply(media, slides, idx) {
    var go = function () {
      if (media.__dhScrub !== idx) return;
      slides.forEach(function (img, i) { img.classList.toggle('is-active', i === idx); });
      media.__dhIndex = idx;
    };
    var target = slides[idx];
    if (loaded(target)) go();
    else target.addEventListener('load', go, { once: true });
  }

  document.addEventListener('pointermove', function (event) {
    if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;
    if (event.target.closest('button')) return;
    var media = event.target.closest(SEL);
    if (!media) return;
    var slides = media.querySelectorAll('.dh-card-slide');
    if (slides.length < 3) return;
    var n = Math.min(slides.length, MAX);
    if (media.__dhT0 == null) {
      media.__dhT0 = event.timeStamp;
      media.classList.add('is-nav');
      for (var i = 0; i < n; i++) {
        var src = slides[i].getAttribute('data-dh-src');
        if (src) { slides[i].src = src; slides[i].removeAttribute('data-dh-src'); }
      }
    }
    if (event.timeStamp - media.__dhT0 < HOLD) return;
    var rect = media.getBoundingClientRect();
    if (!rect.width) return;
    var idx = Math.floor((event.clientX - rect.left) / rect.width * n);
    idx = Math.max(0, Math.min(n - 1, idx));
    if (media.__dhScrub === idx) return;
    media.__dhScrub = idx;
    media.classList.add('is-scrub');
    var dots = ensureDots(media, n);
    Array.prototype.forEach.call(dots.children, function (dot, i) { dot.classList.toggle('is-on', i === idx); });
    apply(media, slides, idx);
  }, { passive: true });

  // Leaving the card ends the scrub (dh-card-gallery.js puts the card back on photo 1).
  document.addEventListener('pointerout', function (event) {
    if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;
    var card = event.target.closest('.dh-card--gallery');
    if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) return;
    var media = card.querySelector('[data-dh-card-media]');
    if (!media) return;
    media.classList.remove('is-scrub');
    media.__dhScrub = null;
    media.__dhT0 = null;
  }, { passive: true });
})();
